module.exports = __webpack_public_path__ + "img/Perforated_Steel.d8559785.jpg";